<template>
  <div class="resource-page">
    <!-- 顶部统计卡片 -->
    <div class="top-stats">
      <div
        class="stat-card"
        v-for="(card, idx) in topStats"
        :key="idx"
        :style="{ background: 'linear-gradient(135deg, ' + card.startColor + ' 0%, ' + card.endColor + ' 100%)' }"
      >
        <div class="card-icon">
          <i :class="card.icon"></i>
        </div>
        <div class="card-content">
          <p class="card-label">{{ card.label }}</p>
          <p class="card-value">{{ card.value }}</p>
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-container">
      <!-- 左侧分类导航 -->
      <nav class="left-nav">
        <div class="nav-header">
          <h3>内容分类</h3>
          <span class="nav-total">共{{ totalCategories }}个分类</span>
        </div>
        <div class="nav-tabs">
          <div
            class="tab-item"
            v-for="(category, idx) in categories"
            :key="idx"
            :class="{ active: currentTab === idx }"
            @click="currentTab = idx"
          >
            <span class="tab-text">{{ category.name }}</span>
            <span class="tab-badge">{{ category.count }}</span>
          </div>
        </div>
      </nav>

      <!-- 右侧资源列表 -->
      <div class="right-content" v-if="categories.length">
        <div class="category-header">
          <h2 class="category-title" v-if="categories.length">{{ categories[currentTab].name }}</h2>
          <div class="category-meta" v-if="categories.length">
            <span v-for="(type, idx) in ['视频', '文档', '图片']" :key="idx">
              <i class="meta-dot" :style="{ background: typeColors[type] }"></i>
              {{ type }}: {{ categories[currentTab][type] || 0 }}
            </span>
          </div>
        </div>

        <div class="resource-list">
          <div class="list-header">
            <div class="header-item">资源名称</div>
            <div class="header-item">所属章节</div>
            <div class="header-item">文件大小</div>
            <div class="header-item">资源类型</div>
          </div>
          <div class="list-body">
            <div
              class="list-row"
              v-for="(res, idx) in categories[currentTab].resources"
              :key="idx"
              :class="'type-' + res.type"
              @click="handleResourceClick(res)"
              :title="res.type === '虚拟仿真' ? '点击打开文件' : '点击预览'"
            >
              <div class="row-item res-name">
                <i :class="'icon-' + res.type" class="res-icon"></i>
                {{ res.name }}
              </div>
              <div class="row-item">{{ res.chapter }}</div>
              <div class="row-item">{{ res.size }}</div>
              <div class="row-item">{{ res.type }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 资源预览弹出层 -->
    <div v-if="showPreview" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <span class="modal-title">{{ currentPreview.name }}</span>
          <div class="modal-actions">
            <button
              class="fullscreen-btn"
              @click="toggleFullscreen"
              aria-label="全屏"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4H16V6H8V4ZM8 18H16V20H8V18ZM4 8V16H6V8H4ZM18 8V16H20V8H18Z" fill="currentColor"/>
              </svg>
            </button>
            <button
              class="close-btn"
              @click.stop="closeModal"
              aria-label="关闭"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <!-- 加载提示 -->
          <div v-if="modalLoading" class="modal-loading">
            <div class="spinner large"></div>
            <span>内容加载中...</span>
          </div>
          <!-- 实际内容 -->
          <iframe
            ref="modalIframe"
            v-else
            v-if="modalType === 'web'"
            :src="currentPreview.ossPreviewUrl"
            frameborder="0"
            style="width: 100%; height: 100%"
            class="iframe-content"
            @load="handleModalLoad"
          ></iframe>
        </div>
      </div>
    </div>
    <!--<el-dialog
      :title="currentPreview && currentPreview.name || '资源预览'"
      :visible.sync="showPreview"
      :width="previewWidth"
      :before-close="handleDialogClose"
      append-to-body
      class="custom-dialog"
    >
      <template v-if="currentPreview && currentPreview.type === '视频'">
        <video :src="currentPreview.url" controls width="100%" height="500px" preload="metadata" class="video-player">
          您的浏览器不支持视频播放
        </video>
      </template>

      <template v-else-if="currentPreview && currentPreview.type === '文档'">
        <iframe
          :src="['https://view.officeapps.live.com/op/embed.aspx?src=', encodeURIComponent(currentPreview.url)].join('')"
          frameborder="0"
          style="width: 100%; height: 600px;"
        ></iframe>
      </template>

      <template v-else-if="currentPreview && currentPreview.type === '图片'">
        <img :src="currentPreview.url" alt="图片预览" class="image-preview">
      </template>

      <template v-else>
        <div class="preview-placeholder">
          <i class="el-icon-info"></i>
          <p>暂不支持在线预览此类型文件</p>
        </div>
      </template>
    </el-dialog>-->
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        lessonId: 1,
        currentTab: 0,
        showPreview: false,
        currentPreview: null,
        previewWidth: '80%',
        typeColors: {
          视频: '#FF6B6B',
          文档: '#4285F4',
          图片: '#34A853',
          虚拟仿真: '#FBBC05'
        },
        topStats: [],
        categories: [],
        modalType: "web",
        modalTitle: "",
        modalLoading: false
      }
    },
    computed: {
      totalCategories(){
        return this.categories.length
      }
    },
    methods: {
      handleResourceClick(res) {
        const type = res.type;
        if (type === '虚拟仿真') {
          window.open("https://yq.keming365.com/webclient?appliId="+res.url, '_blank');
          return;
        }
        if (['文档'].indexOf(type) !== -1) {
          const objectName = res.url;
          axios.post('/api/doc-preview/oss/path', { objectName: objectName }).then(response => {
            if (response.data.code === 200) {
              this.modalLoading = true;
              this.currentPreview = res;
              this.currentPreview.ossPreviewUrl = response.data.data
              this.showPreview = true;
              this.previewWidth = type === '文档' ? '80%' : '90%';
              this.modalType = "web";
            } else {
              this.ossPreviewUrl = null;
              this.$message.error('文档预览地址获取失败');
            }
          }).catch(() => {
            this.ossPreviewUrl = null;
            this.$message.error('文档预览请求出错');
          }).finally(() => {
          });
        }

        if (['视频', '图片'].indexOf(type) !== -1) {
          const objectName = res.url;
          this.currentPreview = res;
          this.currentPreview.ossPreviewUrl = "https://oss.keming365.com/"+objectName
          this.showPreview = true;
          this.previewWidth = type === '文档' ? '80%' : '90%';

          this.modalType = "web";
          this.modalLoading = true;
        }
      },
      // 模态框内容加载完成
      handleModalLoad() {
        this.modalLoading = false; // iframe加载完成后隐藏提示
      },
      closeModal() {
        this.showPreview = false;
        this.currentPreview.ossPreviewUrl = '';
        this.modalLoading = false; // 关闭时重置状态
      },
      // 全屏功能（保持原有逻辑）
      toggleFullscreen() {
        this.$nextTick(() => {
          const el = this.modalType === 'web' ? this.$refs.modalIframe : this.$refs.modalVideo;
          if (el.requestFullscreen) {
            el.requestFullscreen();
          } else {
            alert('当前浏览器不支持全屏功能');
          }
        });
      },
      loadTopStats() {
        axios.get(`/api/lessons-resources/${this.lessonId}/stats`)
          .then(res => {
            const data = res.data;
            this.topStats = [
              {
                label: '课程资源总数',
                value: `${data.totalResources}个`,
                icon: 'fa fa-folder-o',
                startColor: '#E8F4FF',
                endColor: '#F0F9FF'
              },
              {
                label: '视频总时长',
                value: `${data.totalVideoMinutes}分钟`,
                icon: 'fa fa-video-camera',
                startColor: '#FFF0F0',
                endColor: '#FFF8F8'
              },
              {
                label: '文档总数',
                value: `${data.totalDocuments}个`,
                icon: 'fa fa-file-text-o',
                startColor: '#F0F9EB',
                endColor: '#F8FFF2'
              },
              {
                label: '图片数',
                value: `${data.totalSimulations}个`,
                icon: 'fa fa-cubes',
                startColor: '#FFF7E6',
                endColor: '#FFFCEB'
              }
            ]
          })
      },
      loadCategories() {
        axios.get(`/api/lessons-resources/${this.lessonId}/categories`)
          .then(res => {
            this.categories = res.data;
          })
      }
    },
    created() {
      this.loadTopStats();
      this.loadCategories();
    }
  }
</script>

<style scoped>
  /* 全局样式重置 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
    --radius: 12px;
    --shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    --transition: all 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  .resource-page {
    min-height: 100vh;
    padding: 32px 48px;
    background: #F8FAFC;
    font-family: var(--font-family);
  }

  /* 顶部统计卡片 */
  .top-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-bottom: 40px;
  }

  .stat-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    border-radius: var(--radius);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: var(--transition);
    cursor: default;
  }

  .stat-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow);
  }

  .card-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  .card-label {
    font-size: 14px;
    color: #64748B;
    margin-bottom: 4px;
  }

  .card-value {
    font-size: 20px;
    font-weight: 600;
    color: #1E293B;
  }

  /* 主内容区布局 */
  .main-container {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 32px;
  }

  /* 左侧导航 */
  .left-nav {
    background: white;
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 24px;
  }

  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .nav-header h3 {
    font-size: 16px;
    color: #1E293B;
  }

  .nav-total {
    font-size: 12px;
    color: #64748B;
  }

  .nav-tabs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tab-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: var(--transition);
  }

  .tab-item:hover {
    background: #F1F5F9;
  }

  .tab-item.active {
    background: #E0F2FE;
    transform: translateX(4px);
  }

  .tab-item.active .tab-text {
    color: #0284C7;
    font-weight: 600;
  }

  .tab-text {
    font-size: 14px;
    color: #334155;
  }

  .tab-badge {
    font-size: 12px;
    color: #64748B;
    background: #E2E8F0;
    padding: 2px 8px;
    border-radius: 12px;
  }

  /* 右侧内容 */
  .right-content {
    background: white;
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 32px;
  }

  .category-header {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #F1F5F9;
  }

  .category-title {
    font-size: 24px;
    color: #1E293B;
    margin-bottom: 12px;
  }

  .category-meta {
    display: flex;
    gap: 24px;
    font-size: 14px;
    color: #64748B;
  }

  .meta-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
  }

  /* 资源列表 */
  .resource-list {
    width: 100%;
  }

  .list-header {
    display: grid;
    grid-template-columns: 3fr 1fr 1fr 1fr;
    padding: 0 16px 12px;
    border-bottom: 1px solid #F1F5F9;
  }

  .header-item {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
  }

  .list-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .list-row {
    display: grid;
    grid-template-columns: 3fr 1fr 1fr 1fr;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    background: #FAFAFA;
    transition: var(--transition);
    cursor: pointer;
  }

  .list-row:hover {
    background: #F8FAFC;
    transform: translateX(4px);
  }

  .row-item {
    font-size: 14px;
    color: #334155;
  }

  .res-name {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .res-icon {
    font-size: 16px;
  }

  /* 资源类型颜色（匹配Font Awesome 4图标类名） */
  .type-视频 .res-icon { color: #FF6B6B; }
  .type-文档 .res-icon { color: #4285F4; }
  .type-图片 .res-icon { color: #34A853; }
  .type-虚拟仿真 .res-icon { color: #FBBC05; }

  /* 弹出层样式 */
  .custom-dialog .el-dialog__header {
    background: #F8FAFC;
    border-bottom: 1px solid #F1F5F9;
    padding: 16px 24px;
  }

  .custom-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1E293B;
  }

  .custom-dialog .el-dialog__body {
    padding: 24px;
  }

  .video-player {
    background: #000;
    border-radius: 8px;
    overflow: hidden;
  }

  .image-preview {
    max-width: 100%;
    max-height: 600px;
    margin: 0 auto;
    border-radius: 8px;
  }

  .preview-placeholder {
    text-align: center;
    padding: 40px;
    color: #64748B;
  }

  .preview-placeholder .el-icon-info {
    font-size: 40px;
    margin-bottom: 16px;
  }

  /* 模态框样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  /* 模态框z-index提升（确保始终在最上层） */
  .modal-mask {
    z-index: 1001; /* 原1000，提升1层 */
  }

  .modal-container {
    width: 90%;
    max-width: 1024px;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  .modal-container {
    width: 95%;
    border-radius: 12px;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #1e293b;
    color: white;
  }

  .modal-title {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0;
  }

  .modal-actions {
    display: flex;
    gap: 12px;
  }

  .modal-actions button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s ease;
  }

  .modal-actions button:hover {
    color: #ff4757; /* 红色强调 */
  }

  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .card {
      width: 100%;
      max-width: 360px;
      margin: 8px auto;
    }

    .image-wrapper {
      height: 160px;
    }

    .modal-container {
      width: 95%;
      border-radius: 12px;
    }

    .modal-content {
      height: 50vh;
      padding: 16px;
    }
  }

  /* 模态框加载提示 */
  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
    position: relative;
  }

  .modal-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    color: #64748b;
    font-size: 16px;
  }

  /* 加载动画 */
  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #e5e7eb;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .spinner.large {
    width: 24px;
    height: 24px;
    border-width: 3px;
  }

  .iframe-content {
    border-radius: 12px;
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/tp/ResourcePage.vue